import {canBeOptimisticallyParsed, md2html} from '@github-ui/md2html'
import {type ConnectionOperation, OPTIMISTIC_KEY, type SetFieldsOperation} from '@github-ui/optimistic-connection'

/** Identifies the connection a comment write targets for TanStack-backed readers. */
export type OptimisticConnection = {ownerId: string; connectionPath: string[]}
export function addCommentOperation({
  connectionPath,
  node,
  temporaryId,
  fallbackId,
}: {
  connectionPath: string[]
  node: (Record<string, unknown> & {id?: string | null}) | null | undefined
  temporaryId?: string
  fallbackId: string
}): ConnectionOperation {
  const payloadId = node?.id
  if (!node || typeof payloadId !== 'string') return {type: 'setFields', id: fallbackId, fields: {}}

  return {
    type: 'addToConnection',
    connectionPath,
    node: {...node, id: payloadId, ...(temporaryId ? {[OPTIMISTIC_KEY]: temporaryId} : {})},
    anchor: {at: 'end'},
    counts: [{path: [...connectionPath, 'totalCount'], delta: 1}],
  }
}

export function deleteCommentOperation(connectionPath: string[], nodeId: string): ConnectionOperation {
  return {
    type: 'removeFromConnection',
    connectionPath,
    nodeId,
    counts: [{path: [...connectionPath, 'totalCount'], delta: -1}],
  }
}

export function updateCommentOperation(nodeId: string, body: string, bodyVersion?: string): SetFieldsOperation {
  return {
    type: 'setFields',
    id: nodeId,
    fields: canBeOptimisticallyParsed(body)
      ? {body, bodyHTML: md2html(body, {trustedTypes: true}), ...(bodyVersion === undefined ? {} : {bodyVersion})}
      : {},
  }
}
